import { VaultCard } from 'structure/pv2/dynavault/components/VaultCard';
import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { VaultCardCreate } from 'structure/pv2/dynavault/components/VaultCardCreate';
import { appConfig } from 'utils/app.config';
import { VaultCardConnectWallet } from 'structure/pv2/dynavault/components/VaultCardConnectWallet';
import { useConnection } from 'wagmi';
import { useContext } from 'react';
import { AuthContext } from 'structure/providers/AuthProvider';
import { VaultStatusFilter } from 'structure/pv2/dynavault/types';

type DynaVaultListCardsProps = {
  vaultList: DynaVault[];
  vaultStatusFilter: VaultStatusFilter;
};

export const VaultListCards = (props: DynaVaultListCardsProps) => {
  const { vaultList, vaultStatusFilter } = props;
  const account = useConnection();
  const { verified } = useContext(AuthContext);

  return (
    <div className='flex flex-row gap-6 overflow-x-scroll lg:flex-wrap lg:overflow-x-auto'>
      {appConfig.featureFlags.ENABLE_VAULT_CREATE &&
      vaultStatusFilter === 'open' ? (
        <VaultCardCreate />
      ) : null}
      {appConfig.featureFlags.ENABLE_VAULT_CREATE &&
      account.isConnected &&
      vaultStatusFilter === 'open' &&
      !verified ? (
        <div className='lg:flex-1'>
          <VaultCardConnectWallet />
        </div>
      ) : null}
      {vaultList.map((vault) => (
        <VaultCard key={`${vault.chainId}:${vault.address}`} vault={vault} />
      ))}
    </div>
  );
};
